/**
 * finance-time-store — 财务页时间范围（period 快捷档 / 自定义 from-to）全局轻状态。
 *
 * 为何用 store 而非 prop/context：FinancePage 顶部时间控件与消费数据的 finance hook 散在多个子面板组件，
 * 用 Zustand store 让各 hook 直接读取（同 app-scope-store 模式），避免逐层 prop 透传 / JSX Provider 包裹。
 * 仅财务页消费；离开页保留上次选择无害。
 */

import { create } from 'zustand';
import type { FinanceTimeQuery } from '~/hooks/use-finance';

type FinanceTimeState = {
  /** 当前时间窗：自定义 from/to 优先，否则 period 快捷档（24h/7d/30d/90d/ytd）。默认近 30 天 */
  time: FinanceTimeQuery;
  setTime: (time: FinanceTimeQuery) => void;
};

export const useFinanceTimeStore = create<FinanceTimeState>((set) => ({
  time: { period: '30d' },
  setTime: (time) => set({ time }),
}));
